import ECOPortal from '@/views/integrations/ECOPortalExports.vue'

export const ecoPortalRoutes = {
  path: '/integrations/eco-portal',
  name: 'integrationEcoPortal',
  meta: { requiresAuth: true, title: 'ECO Portal Exports - Innovation Law Lab Platform' },
  component: ECOPortal,
  props: true,
}
